import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { invoiceAPI } from '../services/api';
import { Spinner, EmptyState, Badge, Button, PageHeader } from '../components/Common';

const InvoicesPage = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');

  useEffect(() => {
    invoiceAPI.getAll()
      .then(r => setInvoices(r.data.invoices))
      .catch(() => toast.error('Invoices load nahi hue'))
      .finally(() => setLoading(false));
  }, []);

  const downloadPDF = async (id, num) => {
    try {
      const res = await invoiceAPI.downloadPDF(id);
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url; a.download = `${num}.pdf`; a.click();
      toast.success('PDF download ho gaya!');
    } catch { toast.error('PDF download nahi hua'); }
  };

  const filtered = invoices.filter(inv =>
    !search ||
    inv.invoice_number.toLowerCase().includes(search.toLowerCase()) ||
    inv.customer?.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page">
      <PageHeader
        title="📋 All Invoices"
        subtitle={`${invoices.length} total`}
      />

      <div className="search-wrap" style={{ marginBottom:20, maxWidth:360 }}>
        <span className="search-icon">🔍</span>
        <input
          className="form-input"
          placeholder="Invoice number ya customer..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ paddingLeft:34 }}
        />
      </div>

      <div className="card">
        <div className="table-wrap">
          {loading ? <Spinner /> : filtered.length === 0 ? (
            <EmptyState icon="📋" title="Koi invoices nahi" message="Billing page se banao" />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Invoice #</th><th>Customer</th><th>Total</th>
                  <th>WhatsApp</th><th>Email</th><th>Date</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(inv => (
                  <tr key={inv.id}>
                    <td style={{ color:'var(--accent)', fontWeight:600 }}>
                      {inv.invoice_number}
                    </td>
                    <td>
                      <div>{inv.customer?.name||'Walk-in'}</div>
                      {inv.customer?.phone && (
                        <div style={{ fontSize:11, color:'var(--text3)' }}>
                          {inv.customer.phone}
                        </div>
                      )}
                    </td>
                    <td style={{ fontWeight:700, color:'var(--accent2)' }}>
                      ₹{parseFloat(inv.total_amount).toLocaleString('en-IN')}
                    </td>
                    <td>
                      {inv.whatsapp_sent
                        ? <Badge variant="green">✅ Sent</Badge>
                        : <Badge variant="gray">—</Badge>}
                    </td>
                    <td>
                      {inv.email_sent
                        ? <Badge variant="green">✅ Sent</Badge>
                        : <Badge variant="gray">—</Badge>}
                    </td>
                    <td style={{ fontSize:12, color:'var(--text2)' }}>
                      {new Date(inv.createdAt).toLocaleDateString('en-IN')}
                    </td>
                    <td>
                      <button
                        className="btn btn-ghost btn-sm"
                        onClick={() => downloadPDF(inv.id, inv.invoice_number)}
                      >
                        ⬇️ PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoicesPage;